import { ErrorHelper } from '@/helpers/ErrorHelper'
import { mapState, mapGetters, mapActions } from 'vuex'
import { RecaptchaSettingsCacheMixin } from '../Booking/RecaptchaSettingsCacheMixin'
import { SelectedSiteIdMixin } from '../Booking/SelectedSiteIdMixin'
import { TurnstileExecuteMixin } from '../Booking/TurnstileExecuteMixin'

export const ClientRegistrationAddMixin = {
  mixins: [SelectedSiteIdMixin, RecaptchaSettingsCacheMixin, TurnstileExecuteMixin],
  data () {
    return {
      error: '',
      signatureData: '',
      signatureMessage: ''
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'clientRegistrationModel'
    ]),
    ...mapState('ClientRegistration', [
      'addingClientRegistration',
      'contractTemplate'
    ]),
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    clientRegistrationAddModel () {
      return Object.assign({}, this.clientRegistrationModel, {
        recaptcha: this.recaptcha,
        signatureData: this.signatureData
      })
    },
    recaptchaValid () {
      return !this.recaptchaEnabled || !!this.clientRegistrationAddModel.recaptcha
    },
    signatureRequired () {
      return !!this.contractTemplate && !!this.contractTemplate.signatureRequired
    },
    signatureValid () {
      return !this.signatureRequired || !!this.signatureData
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validateSignature()
    }
  },
  methods: {
    ...mapActions('ClientRegistration', [
      'addClientRegistration'
    ]),
    tryAddClientRegistration () {
      const self = this
      self.error = ''
      if (!self.signatureValid || !self.selectedSiteId || self.pendingRecaptcha || self.addingClientRegistration) {
        return
      }
      if (!self.recaptchaValid) {
        self.requestRecaptcha(self.tryAddClientRegistration)
        return
      }
      self.addClientRegistration({ siteId: this.selectedSiteId, payload: self.clientRegistrationAddModel })
        .then(response => self.afterClientRegistrationAdded(response.data))
        .catch(error => {
          self.error = ErrorHelper.getError(error)
          self.resetRecaptcha()
        })
    },
    afterClientRegistrationAdded () {
      // override if necessary
    },
    validateSignature () {
      this.signatureMessage = this.signatureValid ? '' : 'Please sign the contract before submitting.'
    }
  }
}
